import { AxiosResponse } from 'axios';
import { client } from '@/client';

export type EndUser = {
  ssn: string;
  email: string;
  displayName: string;
  hasValidatedEmail: boolean;
};

export type UpdateEmailRequest = {
  email: string;
};

export async function getOwnEndUser(signal?: AbortSignal): Promise<EndUser> {
  return client
    .get<EndUser>('/inbox/user/me', { signal })
    .then((response) => response.data);
}

export async function updateOwnEndUserEmail(
  email: string,
  signal?: AbortSignal,
): Promise<EndUser> {
  return client
    .put<
      UpdateEmailRequest,
      AxiosResponse<EndUser>
    >('/inbox/user/me', { email }, { signal })
    .then((response) => response.data);
}

export async function deleteOwnEndUser(signal?: AbortSignal): Promise<void> {
  return client
    .delete('/inbox/user/me', { signal })
    .then((response) => response.data);
}

export async function validateEndUserEmail(
  code: string,
  signal?: AbortSignal,
): Promise<void> {
  return client.post('/inbox/user/email/validate', null, {
    params: { code },
    signal,
  });
}
